export default __webpack_public_path__ + "static/media/MTbasico_Frente.44879975.webp";